import React from "react";
import dayjs from "dayjs";
//import { useHistory } from "react-router-dom";
import cx from "classnames";
import _ from "lodash";
import styles from "./Subscription.module.scss";
import * as paths from "features/routing/paths";
import onlineOrderIcon from "images/online-order.svg";
import { Subscription as SubscriptionType } from "types/Subscription";
import { Button, ButtonRole } from "components/Button";
declare let orderContactUrl: string;
export const Subscription: React.FC<{ subscription: SubscriptionType }> = ({
  subscription,
}) => {
  const formattedDate = dayjs(subscription.nextPurchaseDate).format("MM/DD/YY");
  const cycleStatus = _.toLower(subscription.cycleStatus);
  const status =
    cycleStatus === "payment_error"
      ? "Payment Failed"
      : subscription.subscriptionStatus.toLowerCase() === "canceled" ||
        subscription.subscriptionStatus.toLowerCase() === "cancelled"
      ? "Cancelled"
      : _.startCase(_.toLower(subscription.subscriptionStatus));
  const nextFill = status === "Active" ? formattedDate : "N/A";
  const productName = subscription.productName; //.toUpperCase();
  //const history = useHistory();
  let refillFrequency = "30 days";
  if (subscription.planPeriodicity === "daily") refillFrequency = "1 day";
  else if (subscription.planPeriodicity === "weekly")
    refillFrequency = "7 days";
  else if (subscription.planPeriodicity === "monthly")
    refillFrequency = "30 days";
  else if (subscription.planPeriodicity === "quaterly")
    refillFrequency = "90 days";

  const statusClassName =
    status === "Active"
      ? cx(styles.value, styles.active)
      : status === "Payment Failed" || status === "Expired"
      ? cx(styles.value, styles.failed)
      : cx(styles.value, styles.canceled);
  return (
    <div className={styles.subscription}>
      <div className={styles.thumbnail}>
        <img
          className={styles.thumbnailIcon}
          src={onlineOrderIcon}
          alt="" /* NB: alt left blank, redundant with below copy */
        />
        <div className={styles.prodMobile}>{productName}</div>
      </div>
      <div>
        <div className={styles.data}>
          <div className={styles.dataNew}>
            <div className={cx(styles.item, styles.mobHide)}>
              <div className={styles.prop}>Product</div>
              <div className={styles.value}>{productName}</div>
            </div>
            <div className={styles.item}>
              <div className={styles.prop}>Refill Frequency</div>
              <div className={styles.value}>{refillFrequency}</div>
            </div>
            <div className={styles.item}>
              <div className={styles.prop}>Next Refill</div>
              <div className={styles.value}>{nextFill}</div>
            </div>
            <div className={cx(styles.mobileView, styles.bgMobile)}>
              <div className={cx(styles.item, styles.marStatus)}>
                <div className={styles.prop}>Status</div>
                <div className={statusClassName}>{status}</div>
              </div>
              <div className={styles.item}>
                <div className={cx(styles.value, styles.btn)}>
                  {status === "Expired" && (
                    <Button
                      text="Book Appointment"
                      role={ButtonRole.Ghost}
                      size="large"
                      className={styles.btn}
                      onClick={() => {
                        window
                          .open(paths.LOCATIONS_PAGE_SEARCH_URL, "_blank")
                          .focus();
                      }}
                    />
                  )}
                  {status !== "Expired" && (
                    <Button
                      text="Manage"
                      role={ButtonRole.Ghost}
                      size="large"
                      className={styles.btn}
                      onClick={() => {
                        window.open(orderContactUrl, "_blank").focus();
                      }}
                    />
                  )}
                </div>
              </div>
            </div>
            <div className={cx(styles.item, styles.desktopView)}>
              <div className={styles.prop}>Status</div>
              <div className={statusClassName}>{status}</div>
            </div>
            <div className={cx(styles.item, styles.desktopView)}>
              <div className={cx(styles.value, styles.btn)}>
                {status === "Expired" && (
                  <Button
                    text="Book Appointment"
                    role={ButtonRole.Ghost}
                    size="large"
                    className={styles.btn}
                    onClick={() => {
                      window
                        .open(paths.LOCATIONS_PAGE_SEARCH_URL, "_blank")
                        .focus();
                    }}
                  />
                )}
                {status !== "Expired" && (
                  <Button
                    text="Manage"
                    role={ButtonRole.Ghost}
                    size="large"
                    className={styles.btn}
                    onClick={() => {
                      window.open(orderContactUrl, "_blank").focus();
                    }}
                  />
                )}
              </div>
            </div>
          </div>
          {status === "Payment Failed" && (
            <div className={styles.redText}>
              There appears to be an issue with your payment method. Click the
              "MANAGE" button to review & update it now.
            </div>
          )}
          {status === "Expired" && (
            <div className={styles.redText}>
              Your prescription has expired. Click "BOOK APPOINTMENT" to
              schedule eye exam to renew your prescription.
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
